import { ViewMessageCenterFormModal } from "src/app/components";
import { Message, UpsertMessage } from "src/app/types/Message";
import { useIntl } from "react-intl";
import { MessageTransport } from "src/app/transports/Message";
import { IActionsModal } from "src/app/types/actionsModal";
import { toast } from "react-toastify";
import { Form, Formik, FormikHelpers } from "formik";
import { useTemplatesOptions } from "src/app/hooks";
import { useState } from "react";

const ViewMessageCenterFormContainer = (props: IActionsModal<Message>) => {
    const { handleClose = () => {}, entity, updateGridOnSave } = props;

    const { formatMessage } = useIntl();
    const { templatesOptions } = useTemplatesOptions();

    const [currentMessage, setCurrentMessage] = useState<Message>(entity);
    const [loading, setLoading] = useState(false);

    const handleMessageFiles = async (filename: string) => {
        const windowFeatures = "noreferrer=true";
        const link = await MessageTransport.getprivateEmailFiles(filename);

        if (!link) {
            toast.error(formatMessage({ id: "common.notification.error.message" }));

            return;
        }

        window.open(link, "_blank", windowFeatures);
    };

    const handleSubmit = async (_values: UpsertMessage, formikHelpers: FormikHelpers<any>) => {
        try {
            setLoading(true);
            const newMessage = await MessageTransport.sendEmail(_values, currentMessage.id);
            updateGridOnSave && updateGridOnSave(newMessage, false);
            setCurrentMessage(newMessage);
            toast.success(formatMessage({ id: "common.notification.success" }));
            formikHelpers.setFieldValue("newMessage", "");
        } catch (error) {
            toast.error(formatMessage({ id: "common.notification.error" }));
        } finally {
            setLoading(false);
        }
    };

    return (
        <Formik
            initialValues={MessageTransport.formTransformer(currentMessage) as any}
            onSubmit={handleSubmit}
        >
            <Form id="message">
                <ViewMessageCenterFormModal
                    entity={currentMessage}
                    loading={loading}
                    handleClose={handleClose}
                    templatesOptions={templatesOptions}
                    handleMessageFiles={handleMessageFiles}
                />
            </Form>
        </Formik>
    );
};

export default ViewMessageCenterFormContainer;
